import React from "react";

function LedgerTable({ ledgers, onChange, loading }) {
  return (
     <>
        {loading ? (
            <p>Loading...</p>
          ) : (
        <div className="table-responsive">
          <table className="table ledger-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Account Code</th>
                <th>Account Name</th>                
                <th>Group</th>
                <th className="text-end">Debit</th>
                <th className="text-end">Credit</th>
              </tr>
            </thead>
            <tbody>
              {ledgers.map((ledger, index) => {
                /* const debitValue =
                  ledger.debit !== undefined
                    ? ledger.debit
                    : ledger.opening_balance >= 0
                    ? ledger.opening_balance
                    : 0;

                const creditValue =
                  ledger.credit !== undefined
                    ? ledger.credit
                    : ledger.opening_balance < 0
                    ? Math.abs(ledger.opening_balance)
                    : 0; */

                return (
                  <tr className="op-list" key={ledger.id}>
                    <td>
                      {index + 1}
                      <input
                        type="hidden"
                        name={`ledgers[${index}][ledger]`}
                        value={ledger.id}
                      />
                    </td>
                    <td>{ledger.ledger_code}</td>
                    <td>
                      <a className="fw-bold">{ledger.ledger_name}</a>
                    </td>                    
                    <td>{ledger.group?.group_name || "-"}</td>
                    <td>
                      <input
                          type="number"
                          className="form-control text-end debit"
                          value={ledger.debit}
                          data-id={ledger.id}
                          id={`debit-${ledger.id}`}
                          name={`ledgers[${index}][debit]`}
                          onChange={(e) => onChange(index, "debit", e.target.value)}
                          disabled={ledger.credit > 0}
                        />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control text-end credit"
                        value={ledger.credit}
                        data-id={ledger.id}
                        id={`credit-${ledger.id}`}
                        name={`ledgers[${index}][credit]`}
                        onChange={(e) => onChange(index, "credit", e.target.value)}
                        disabled={ledger.debit > 0}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        )}
    </>
  );
}

export default LedgerTable;
